import { PhaseType } from '@schema/phase'
import {
  InitiativeCreationStep,
  initiativeCreationSteps,
} from '../../shared/workflow'
import { CreationStepLayout } from '../blocks/CreationStepLayout'
import { useEffect, useMemo, useState } from 'react'
import { AmenitiesSelectionGrid } from '@app/pages/dashboard/initiative/shared/forms/amenities/AmenitiesSelectionGrid'
import { useInitiativeAutoSave } from '@app/pages/dashboard/initiative/shared/useInitiativeAutoSave'
import { useTranslations } from '@i18n/useLanguage'
import type { InitiativeWithId } from '@app/pages/dashboard/initiative/shared/initiativeTypes'
import type { OnboardingStep } from '@schema/initiative'

const DEFAULT_WORKFLOW_STEP = initiativeCreationSteps.livingAmenities

export const LivingAmenitiesStep = ({
  initiative,
  selectedPhaseType,
  completeStep,
  workflowStep = DEFAULT_WORKFLOW_STEP,
}: {
  initiative: InitiativeWithId
  selectedPhaseType: PhaseType
  completeStep: (step: InitiativeCreationStep) => void
  workflowStep?: OnboardingStep
}) => {
  const view = useTranslations().app.dashboard.initiative.view
  const [selectedIds, setSelectedIds] = useState<number[]>(() =>
    (initiative.amenities ?? []).map((amenity) => amenity.id),
  )

  useEffect(() => {
    setSelectedIds((initiative.amenities ?? []).map((amenity) => amenity.id))
  }, [initiative.amenities])

  const savePayload = useMemo(
    () => ({
      amenities: selectedIds.map((id) => ({ id })),
      onboardingStep: workflowStep,
    }),
    [selectedIds, workflowStep],
  )

  useInitiativeAutoSave(initiative.id, savePayload)

  useEffect(() => {
    completeStep(workflowStep)
  }, [completeStep, workflowStep])

  return (
    <CreationStepLayout
      selectedPhaseType={selectedPhaseType}
      currentStep={workflowStep}
      titleOverride={view.amenitiesSection}
    >
      <AmenitiesSelectionGrid
        initiativeId={initiative.id}
        selectedIds={selectedIds}
        setSelectedIds={setSelectedIds}
      />
    </CreationStepLayout>
  )
}
